import React, { useState, useEffect } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';

import './styles.scss';

const PasswordValitadorBar: React.FC<{ password: string; strength: any; }> = ({
  password,
  strength,
}) => {
  const [passwordStrength, setPasswordStrength] = useState(0);
  const validatorClass = 'password-validator-piece';

  useEffect(() => {
    const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    const symbols = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

    const passwordSymbols = symbols.test(password) ? 2 : 0;
    const passwordNumbers = password
      .split('')
      .filter((letter) => numbers.includes(letter)).length
      ? 1
      : 0;
    const passwordLength = passwordLengthVerification();

    setPasswordStrength(passwordSymbols + passwordNumbers + passwordLength);
    strength(passwordSymbols + passwordNumbers + passwordLength);
  }, [password, strength]);

  const passwordLengthVerification = () => {
    if (password.length >= 8)
      return 2;

    return password.length > 2 ? 1 : 0;
  };

  const classPasswordStrength = (value: number) => {
    return passwordStrength >= value ? ` piece-${passwordStrength}` : '';
  };

  return (
    <Column className="w-100 word-break">
      <Row className="w-100 justify-between">
        <div className={`${validatorClass}${classPasswordStrength(1)}`} />
        <div className={`ml-1 ${validatorClass}${classPasswordStrength(2)}`} />
        <div className={`ml-1 ${validatorClass}${classPasswordStrength(3)}`} />
        <div className={`ml-1 ${validatorClass}${classPasswordStrength(4)}`} />
        <div className={`ml-1 ${validatorClass}${classPasswordStrength(5)}`} />
      </Row>
      <Text size={12} className="color-blue-gray mt-2">
        Use oito ou mais caracteres com uma combinação de letras, números e
        símbolos
      </Text>
    </Column>
  );
};

export default PasswordValitadorBar;
